import { useScrollReveal } from '../../../hooks/useScrollReveal';

const testimonials = [
  {
    quote:
      "On a fait appel à BYD après 4 mois à chercher un commercial sans succès. En 3 semaines, on avait 15 RDV qualifiés et 2 contrats signés. Le ROI est sans appel — on a déjà renouvelé pour 6 mois.",
    name: 'Sophie Marchand',
    role: 'CEO & Co-fondatrice',
    company: 'Lygo Technologies',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20French%20businesswoman%20CEO%20startup%20founder%20portrait%20headshot%2C%20confident%20smile%2C%20modern%20office%20background%2C%20warm%20natural%20lighting%2C%2035%20years%20old%2C%20business%20casual%20blazer%2C%20clean%20professional%20photography&width=120&height=120&seq=avatar-f1&orientation=squarish',
  },
  {
    quote:
      "Ce que j'apprécie avec BYD, c'est la transparence totale. Je vois tout : les appels passés, les objections rencontrées, les résultats semaine par semaine. Mon équipe interne est maintenant focalisée sur les gros deals, pas sur la chasse.",
    name: 'Thomas Lebreton',
    role: 'Directeur Commercial',
    company: 'Novaplex Solutions',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20French%20businessman%20startup%20director%20portrait%20headshot%2C%20confident%20friendly%20smile%2C%20modern%20office%20background%2C%20warm%20natural%20lighting%2C%2040%20years%20old%2C%20business%20casual%20shirt%2C%20clean%20professional%20photography&width=120&height=120&seq=avatar-m1&orientation=squarish',
  },
];

export default function Temoignages() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section id="temoignages" className="bg-white py-24 lg:py-32 relative overflow-hidden">
      {/* Decorative shape */}
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-[#6ECFA0]/5 blur-3xl pointer-events-none" />

      <div ref={ref} className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div
          className={`mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="inline-block text-[#6ECFA0] text-sm font-bold uppercase tracking-widest mb-4">
            Témoignages
          </span>
          <h2 className="text-4xl lg:text-5xl font-black text-[#0A0A0A] leading-tight">
            Ils nous font confiance
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              className={`bg-[#0A0A0A] rounded-3xl p-10 lg:p-12 relative overflow-hidden transition-all duration-700 hover:-translate-y-1 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              } ${i === 1 ? 'lg:mt-12' : ''}`}
              style={{ transitionDelay: `${i * 200}ms` }}
            >
              {/* Decorative quote */}
              <span className="absolute -top-4 left-6 text-[140px] font-black text-[#6ECFA0]/10 leading-none select-none">
                &ldquo;
              </span>

              {/* Quote text */}
              <p className="relative z-10 text-white/85 text-base lg:text-lg leading-loose mb-8">
                {t.quote}
              </p>

              {/* Divider */}
              <div className="w-12 h-0.5 bg-[#6ECFA0] mb-8 rounded-full" />

              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 flex items-center justify-center rounded-full overflow-hidden shrink-0 border-2 border-[#6ECFA0]/30">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-white font-bold text-base">{t.name}</p>
                  <p className="text-white/50 text-sm">{t.role}</p>
                  <p className="text-[#6ECFA0] text-xs font-semibold mt-0.5">{t.company}</p>
                </div>

                <div className="ml-auto flex gap-0.5">
                  {[...Array(5)].map((_, idx) => (
                    <i key={idx} className="ri-star-fill text-[#6ECFA0] text-sm" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Social proof bar */}
        <div
          className={`mt-14 flex flex-wrap justify-center items-center gap-6 lg:gap-12 pt-12 border-t border-[#0A0A0A]/10 transition-all duration-700 delay-400 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          {[
            { icon: 'ri-thumb-up-line', value: '98%', label: 'Taux de satisfaction' },
            { icon: 'ri-group-line', value: '150+', label: 'Entreprises accompagnées' },
            { icon: 'ri-calendar-check-line', value: '4 200+', label: 'RDV générés' },
          ].map((stat) => (
            <div key={stat.label} className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#6ECFA0]/10">
                <i className={`${stat.icon} text-[#6ECFA0]`} />
              </div>
              <div>
                <p className="text-xl font-black text-[#0A0A0A]">{stat.value}</p>
                <p className="text-xs text-[#666]">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
